export default {
    dashboard: {
        groupExposure: 'Izpostavljenost skupine',
        granularityBuckets: 'granularnost: {granularity} · intervali: {buckets}',
        refreshing: 'Osveževanje…',
        loadingAggregate: 'Nalaganje agregata…',
        loadError: 'Agregata ni bilo mogoče naložiti',
        noPositionData: 'Ni podatkov o poziciji za {from} → {to}',
        noPositionDataHint: 'Zaklenite pogodbe, katerih dobava pade v ta razpon, nato osvežite.',
        coverageShowing: 'Prikazano',
        coverageDaysFraction: '{days} od {requested} dni',
        coverageWithData: 's podatki',
        coverageRangeNote:
            'Izbrani razpon je {from} → {to}; dnevi brez zaklenjenih pogodb ali napovedi so izpuščeni iz spodnje časovne osi.',
        selectContract: 'Izberite pogodbo na levi za prikaz podrobnosti',
    },
}
